<template>
  <div class="do">
      <van-sticky>
          <van-nav-bar v-if="!environment" title="关于普惠平台" left-arrow @click-left="onClickLeft" />
      </van-sticky>
    <img src="@/assets/images/about-puhui.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'PuhuiAbout',
  data () {
    return {
      environment: false
    }
  },
  created(){
    this.getIsWxMiniProgram()
    let title = "关于普惠平台";
    if (this.$getUA() === 1) {
        this.$callApp("Android", "onJSAppSetTitle", title); //调用安卓的设置标题方法
        this.$callApp("Android", "SetWebViewZoom", true)
    }else if (this.$getUA() === 2){
        this.$callApp("iOS", "getWebViewTitleMethod", title); //调用IOS设置标题的方法
        this.$callApp("iOS", "EnableWebZoomMethod", true)
    }
  },
  methods: {
     // 判断是否小程序
    async getIsWxMiniProgram() {
      const WxMiniProgram = await this.$getIsWxMiniProgram()
      if (WxMiniProgram) {
        this.environment = true
      } else {
        this.environment = false
      }
    },
    onClickLeft() {
       this.$callApp('Android', 'GoBackAppMethod', '')
       this.$callApp('iOS', 'GoBackAppMethod', '')
    },
  },
}
</script>

<style lang="less" scoped>
img{
  width: 100%;
  height: auto;
  margin-bottom: -3.5px;
}
</style>
